<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid pa-0>
                <v-layout row wrap>
                    <v-flex xs2 py-0>
                        <v-autocomplete v-model="search.merchant" :items="merchants" append-icon="search" label="Merchant" clearable @click:clear="resetFilter(search.merchant)" @change="searchTransactions"></v-autocomplete>
                    </v-flex>
                    <v-flex xs2 py-0>
                        <v-text-field v-model="search.merchantId" append-icon="search" label="Merchant ID" clearable @click:clear="resetFilter(search.merchantId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 py-0>
                        <v-text-field v-model="search.arn" append-icon="search" label="ARN" clearable @click:clear="resetFilter(search.arn)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 py-0>
                        <v-select v-model="search.itemType" :items="itemType" append-icon="search" label="Type" clearable @click:clear="resetFilter(search.itemType)" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2 py-0>
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="search.fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.fromDate" :first-day-of-week="1" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2 py-0>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="search.toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.toDate" :first-day-of-week="1" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>           
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="headers" :items="chargebacks" :expand="expand" item-key="uuid" class="elevation-1" :rows-per-page-items="rowsPerPage" :loading="loading">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="props.expanded = !props.expanded">
                                    <td class="text-xs-left">{{ props.item.merchantName }}</td>
                                    <td class="text-xs-left">{{ props.item.channelName }}</td>
                                    <td class="text-xs-left">{{ props.item.merchantId }}</td>
                                    <td class="text-xs-left">{{ props.item.itemType }}</td>
                                    <td class="text-xs-left">{{ props.item.postDate }}</td>
                                    <td class="text-xs-left">{{ props.item.arn }}</td>
                                    <td class="text-xs-center">{{ props.item.authCode }}</td>
                                    <td class="text-xs-center">{{ props.item.reasonCode }}</td>
                                    <td class="text-xs-center">{{ props.item.reasonCodeDesc }}</td>
                                    <td class="text-xs-center">{{ props.item.disputeCondition }}</td>
                                </tr>
                            </template>
                            <template v-slot:expand="props">
                                <v-card class="" flat color="#ECEFF1">
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs1><b>Amount:</b><span class="expanded ml-2">{{ props.item.amount }} {{ props.item.currency }}</span></v-flex>
                                            <v-flex xs1><b>BIN:</b><span class="expanded ml-2">{{ props.item.bin }}</span></v-flex>
                                            <v-flex xs1><b>Card Holder:</b><span class="expanded ml-2">{{ props.item.holder }}</span></v-flex>
                                            <v-flex xs2><b>Card Expiration:</b><span class="expanded ml-2">{{ props.item.expDate }}</span></v-flex>
                                            <v-flex xs1><b>Last 4 Digits:</b><span class="expanded ml-2">{{ props.item.last4Digits }}</span></v-flex>
                                            <v-flex xs2><b>Processing Time:</b><span class="expanded ml-2">{{ props.item.processing_time }}</span></v-flex>
                                            <v-flex xs1><b>Scheme:</b>
                                                <span v-if="props.item.scheme == 'Visa'" class="expanded ml-2">VISA</span>
                                                <span v-else-if="props.item.scheme == 'MC'" class="expanded ml-2">MASTERCARD</span>
                                            </v-flex>
                                            <v-flex xs2><b>UUID:</b><span class="expanded ml-2">{{ props.item.uuid }}</span></v-flex>
                                        </v-layout>
                                    </v-card-title>
                                </v-card>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data () {
            return {
                headers: [{ text: 'Merchant', sortable: false },
                          { text: 'Channel', sortable: false },
                          { text: 'Merchant ID', sortable: false },
                          { text: 'Type', sortable: false },
                          { text: 'Post Date', sortable: false },
                          { text: 'ARN', sortable: false },
                          { text: 'Auth Code', sortable: false, align: 'center' },
                          { text: 'Reason Code', sortable: false, align: 'center' },
                          { text: 'Description', sortable: false, align: 'center' },
                          { text: 'Dispute Condition', sortable: false, align: 'center' }],
                chargebacks: [],
                expand: true,
                loading: true,
                rowsPerPage: [10, 25, 50, 100],
                merchants: null,
                fromDateModal: false,
                toDateModal: false,
                itemType: [{ text: '1st Chargeback', value: '1st Chargeback'},
                           { text: '2nd Chargeback', value: '2nd Chargeback'},
                           { text: 'Re-presentment', value: 'Re-presentment'},
                           { text: 'VCR Pre Arb Res', value: 'VCR Pre Arb Res'},
                           { text: 'VCR Pre-Complia', value: 'VCR Pre-Complia'}],
                search: { merchant: null,
                          merchantId: null,
                          arn: null,
                          itemType: null,
                          fromDate: new Date().toISOString().substr(0, 10),
                          toDate: new Date().toISOString().substr(0, 10) }
            }
        },
        beforeMount() {
            this.getChargebacks();
        },
        methods: {
            getChargebacks() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-chargebacks-secure-trading',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.chargebacks = response.data;
                    console.log(this.chargebacks);
                    this.merchants = [...new Set(this.chargebacks.map(e => e.merchantName))];
                    this.merchants.sort((a, b) => a.localeCompare(b));

                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            handleDateChange() {
                if(this.search.toDate < this.search.fromDate) {
                    this.search.fromDate = this.search.toDate;
                }
                this.$refs.fromDateDialog.save(this.search.fromDate);
                this.$refs.toDateDialog.save(this.search.toDate);
                this.searchTransactions();
            },
            resetFilter(field) {
                this.field = null;
                this.searchTransactions();
            },
            searchTransactions() {
                this.loading = true;
                
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/search-chargebacks-secure-trading',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.chargebacks = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        }
    }
</script>

<style>
 
</style>
